import React from "react";
import {Card, Empty, Typography} from "antd";
import NotFound from "../cProject-not-found.png";
import {Link} from "react-router-dom";

const resources = ['bid', 'project', 'RFI', 'punch list item', 'task', 'submittal', 'daily log'];

const titleCase = string => {
  const newString = Array.from(string.toLowerCase());
  newString.splice(0, 1, string.slice(0, 1).toUpperCase());
  return newString.join('')
};

const ComponentNotFound = ({resource}) => <Empty image={NotFound} imageStyle={{ height: 50, margin: '8px 0 24px' }} description={
  <Card style={{margin: 'auto', maxWidth: 'fit-content', textAlign: 'left'}}>
    <Typography>
      <Typography.Title level={2} style={{textAlign: 'center'}}>404 {titleCase(resource)} Not Found</Typography.Title>
      <Typography.Paragraph>
        The {resource} you're looking for could not be found. This could be because:
      </Typography.Paragraph>
      <Typography.Paragraph>
        <ul>
          {resources.includes(resource) && <li>You have not been invited to the {resource}.</li>}
          <li>The {resource} has been removed or no longer exists.</li>
          <li>The URL you entered is invalid.</li>
        </ul>
      </Typography.Paragraph>
      <Typography.Paragraph>
        You can return to the <Link to='/'>home page</Link> or <a href='mailto:support@cproject.com'>contact us</a> if you believe this is in error.
      </Typography.Paragraph>
    </Typography>
  </Card>
}/>;

export default ComponentNotFound;



// WEBPACK FOOTER //
// ./src/components/Boilerplate/ComponentNotFound.js